import script from "./Card.vue?vue&type=script&setup=true&lang=js"
export * from "./Card.vue?vue&type=script&setup=true&lang=js"

import "./Card.vue?vue&type=style&index=0&id=22757df5&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22757df5"]])

export default __exports__